
  import { FilterDisplayType } from '@one/types'
  import { Vue, Component, Prop } from 'vue-property-decorator'

  @Component
  export default class FilterLabel extends Vue {
    @Prop({ type: String, required: false, default: null })
    readonly text!: string | null;

    @Prop({ type: String, required: false, default: null })
    readonly icon!: string | null;

    @Prop({
      type: String as () => FilterDisplayType,
      required: false,
      default: FilterDisplayType.DEFAULT,
    })
    readonly displayType!: FilterDisplayType;
  }
